/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: sj
 * @LastEditTime: 2022-05-19 09:50:10
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col } from 'antd'
import form from 'antd/lib/form'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { getSystemList } from '../tenant/setting/TenentSettingSlice'
import { ChineseMedicine } from './chineseMedicine/ChineseMedicine'
import { Diagnosis } from './diagnosis/Diagnosis'
import { LimitPrice } from './limitPrice/LimitPrice'
import { Materials } from './materials/Materials'
import styles from './Medical.module.css'
import { WesternMedicine } from './westernMedicine/Materials'

export const Medical = () => {
  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  useEffect(() => {
    dispatch(getSystemList())
  }, [])

  return (
    <Col className={styles.container}>
      <TabBar
        defaultActiveKey={location.state ? location.state.station : '1'}
      >
        <TabPane key='1' tab='西药'>
          <WesternMedicine />
        </TabPane>
        <TabPane key='2' tab='中药'>
          <ChineseMedicine />
        </TabPane>
        <TabPane key='3' tab='诊疗项目'>
          <Diagnosis />
        </TabPane>
        <TabPane key='4' tab='材料'>
          <Materials />
        </TabPane>
        {/* <TabPane key='5' tab='医保限价'>
          <LimitPrice />
        </TabPane> */}
      </TabBar>
    </Col>
  )
}
